
    import { mapGetters } from 'vuex';

    export default {
        name: 'HistogramMarketAvg',

        data() {
            return {};
        },

        computed: {
            ...mapGetters('job', {
                $_marketPay: 'marketPay',
                $_marketAveragePay: 'marketAveragePay',
                $_marketAveragePayShortLabel: 'marketAveragePayShortLabel',
                $_isChartTypeRange: 'isChartTypeRange',
                $_chartData: 'chartData',
                $_isPayTypeHourly: 'isPayTypeHourly',
                $_pay: 'pay',
            }),

            marketAvgPosition() {
                const averagePay = this.$_marketAveragePay;
                let maxPayMin = Math.min(this.$_marketPay.payMax, 350000);
                let percent = 0;
                if (!this.$_isChartTypeRange) {
                    maxPayMin = this.$_chartData[this.$_chartData.length - 1].min_pay;
                    let minPay = this.$_chartData[0].min_pay;
                    if (this.$_isPayTypeHourly) {
                        maxPayMin = Math.round(maxPayMin / 1976);
                        minPay = Math.round(minPay / 1976);
                    }
                    if (maxPayMin > averagePay) {
                        percent = Math.round(((averagePay - minPay) * (100 * (this.$_chartData.length - 1) / this.$_chartData.length)) / (maxPayMin - minPay));
                    } else {
                        const payMax = Math.max(this.$_marketPay.payMax, this.$_pay.payMax);
                        percent = Math.round((100 * ((this.$_chartData.length - 1) / this.$_chartData.length)) + ((averagePay - maxPayMin) / (payMax - maxPayMin) * (100 * (1 / this.$_chartData.length))));
                    }
                } else {
                    const payMin = Math.min(this.$_marketPay.payMin, this.$_pay.payMin);
                    percent = Math.round(((averagePay - payMin) * 100 / (maxPayMin - payMin)));
                }
                // Make sure the market salary average pointer never gets out of the chart
                if (percent > 100) {
                    percent = 100;
                } else if (percent < 0) {
                    percent = 0;
                }
                return percent;
            },
        },

        methods: {},
    };
